import { ProductSubtype } from '@/api';

export const feedProductSubtypeOptions: { value: ProductSubtype; text: string }[] = [
	{ value: ProductSubtype.Feed, text: 'Feed' },
	{ value: ProductSubtype.Fert, text: 'Fertiliser' },
];

export const feedProductSubtypeLabelMap: Record<ProductSubtype, string> = Object.fromEntries(
	feedProductSubtypeOptions.map(o => [o.value, o.text]),
) as Record<ProductSubtype, string>;
